import { useRouter } from 'next/router';
import { classnames } from 'tailwindcss-classnames';
import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { RouteData } from '@sitecore-jss/sitecore-jss-react';
import useDictionary from 'lib/sitecore/use-dictionary';
import Container from 'components/helpers/Container';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';

export type FormWrapperProps = Sitecore.Override.ComponentBase &
  RouteData &
  Components.Forms.Form.Fields.FormWrapper;

const FormWrapper = ({ fields, rendering }: FormWrapperProps): JSX.Element => {
  const router = useRouter();
  const { Form_FieldsRequired: labelFieldsRequired } = useDictionary();
  if (!fields) {
    return <MissingDataSource />;
  }
  const headingProps = propsFromFields(fields);
  const shouldShowRequiredLabel = !!router?.isReady && fields.showRequiredLabel.value;
  return (
    <Container size="standard" dataComponent="authorable/form/form-wrapper">
      <div>
        <Heading {...headingProps} className={classnames('mb-4')} />
        {shouldShowRequiredLabel && (
          <div className={classnames('text-red-error', 'italic', 'mb-10')}>
            <span>*</span>
            {labelFieldsRequired || 'Required'}
          </div>
        )}
        <PlaceholderWrapper name="sitecore-form" rendering={rendering} />
      </div>
    </Container>
  );
};

export default FormWrapper;
